export const downloadAsFile = (props: {
  data: string;
  fileName: string;
  type: string;
}) => {
  const fileData = new Blob([props.data], { type: props.type });
  const csvURL = URL.createObjectURL(fileData);
  const link = document.createElement("a");
  link.href = csvURL;
  link.download = `${props.fileName}`;
  document.body.append(link);
  link.click();
  link.remove();
};
